import React from "react";
import { Seo } from "../components/Seo";
import { SEO } from "../seo";
import { Contact } from "../components/Contact";

export default function AssistenzaPage() {
  return (
    <div className="pt-10">
      <Seo {...SEO.assistenza} />
      <Contact />
    </div>
  );
}
